import { useEffect, useRef, useState } from "react";
import { TournamentUserResponse } from "../../../../../api/pub-tournament";
import Pagination from "../../../../../components/web/Pagination";
import {
  TournamentItmBack,
  TournamentItmTable,
  TournamentItmTableHeader,
  TournamentSinInItem,
  TournamentSininWrapper,
  TournamentTableItemWrapper,
} from "../tournament-itm/style";

interface TournamentStateItmProps {
  userList: TournamentUserResponse[];
  type: string;
}
const TournamentStateSitin = ({ userList, type }: TournamentStateItmProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [list, setList] = useState<TournamentUserResponse[]>([]);
  const [more, setMore] = useState<boolean>(false);
  const size = 7;
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(more ? contentRef.current.scrollHeight + 40 : 56);
    }
  }, [more]);

  useEffect(() => {
    setTotalPages(Math.max(1, Math.ceil(userList.length / size)));
    setList(userList.slice((currentPage - 1) * size, currentPage * size));
  }, [userList]);

  useEffect(() => {
    setList(userList.slice((currentPage - 1) * size, currentPage * size));
  }, [currentPage]);

  return (
    <TournamentSininWrapper
      ref={contentRef}
      open={more}
      contentHeight={contentHeight}
    >
      <div className="header" onClick={() => setMore(!more)}>
        <div className="title">
          {type === "sitin" ? "싯인" : "싯아웃"} 플레이어
        </div>
        <img src={`/image-web/tournament/down-arrow.svg`} alt="more" />
      </div>
      <TournamentItmBack open={more}>
        <TournamentItmTable isHeight={totalPages > 1}>
          <TournamentItmTableHeader>
            <div className="item">닉네임</div>
            <div className="item">리엔트리</div>
            <div className="item">애드온</div>
          </TournamentItmTableHeader>
          <TournamentTableItemWrapper>
            {list.length === 0 ? (
              <div className="no-data">플레이어가 없습니다. </div>
            ) : (
              list.map((item, index) => (
                <TournamentSinInItem key={index}>
                  <div className="item">{item.nickname}</div>
                  <div className="item">
                    {item.rebuyCount ? item.rebuyCount.toLocaleString() : "-"}
                  </div>
                  <div className="item">
                    {item.addonCount ? item.addonCount.toLocaleString() : "-"}
                  </div>
                </TournamentSinInItem>
              ))
            )}
          </TournamentTableItemWrapper>
        </TournamentItmTable>
        {totalPages > 1 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
            size={22}
          ></Pagination>
        )}
      </TournamentItmBack>
    </TournamentSininWrapper>
  );
};
export default TournamentStateSitin;
